import { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import NonReferredCustomersList from "./NonReferredCustomersList";
import ReferredCustomersList from "./ReferredCustomersList";

const UserListTab = () => {
  const [activeTab, setActiveTab] = useState("referred");

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <h1><strong>Franchises</strong></h1>

      <Tabs activeKey={activeTab} onSelect={setActiveTab} id="franchise-tabs">
        <Tab eventKey="referred" title="Referred Customers">
          <ReferredCustomersList />
        </Tab>

        <Tab eventKey="non-referred" title="Non-Referred Customers">
          <NonReferredCustomersList />
        </Tab>
      </Tabs>
    </div>
  );
};

export default UserListTab;